export default __webpack_public_path__ + "static/media/ISCO CLASS-10 EXAM PATTERN 2025.5f32025a.pdf";